import {  Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import MobileBottomNav from "./components/MobileBottomNav/MobileBottomNav";
import HomeScreen from "./screen/HomeScreen";
import ErrorScreen from "./screen/ErrorScreen";
import SaaSLandingPage from "./screen/SaaSLandingPage";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Cart from "./screen/Cart";
import MenuCardScreen from "./screen/MenuCardScreen";
import Connect from "./screen/Connect";
import ReelsScreen from "./screen/ReelsScreen";
import { setupCartCleanup } from "./utils/cartCleanup";
import { useDispatch } from "react-redux";
import { fetchProfile } from "./redux/menu/ProfileSlice";

const theme = createTheme({
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
  shape: {
    borderRadius: 12,
  },
});
function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  
  // Set up cart cleanup on app start
  useEffect(() => {
    setupCartCleanup();
  }, []);
  
  // Only fetch profile if we're not on the landing page and have a store ID in URL
  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    const isLandingPage = location.pathname === "/";
    
    if (!isLandingPage && pathParts.length > 0) {
      dispatch(fetchProfile())
        .unwrap()
        .then((data) => {
          // navigate("/dashboard") if needed
        })
        .catch((err) => {
          console.error("Profile failed:", err);
          navigate("/page/notFound");
        });
    }
  }, [dispatch, location.pathname, navigate]);

  // Check if we're on the landing page
  const isLandingPage = location.pathname === "/";

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        {!isLandingPage && <Navbar />}
        <Routes>
          <Route path="/" element={<SaaSLandingPage />} />
          <Route path="/:id" element={<HomeScreen />} />
          <Route path="/:id/orders" element={<Cart />} />
          <Route path="/:id/table-top-menu" element={<MenuCardScreen />} />
          <Route path="/:id/connect" element={<Connect />} />
          <Route path="/:id/reels" element={<ReelsScreen />} />
          <Route path="*" element={<ErrorScreen />} />
        </Routes>
        {!isLandingPage && <MobileBottomNav />}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
